// Scrolls a newly highlighted row into view on every selection change.
// We can't rely on bits-ui here: its #scrollSelectedIntoView treats the
// first row of a group specially — it scrolls only the group *heading*
// into view and returns early without scrolling the row itself, so a tall
// two-line row (docs and settings results carry a breadcrumb subtitle)
// ends up fully below the fold with an invisible highlight. Scrolling the
// row afterwards instead produces a visible two-step scroll on every
// group-boundary crossing, so do the whole thing once, synchronously:
// by the time bits-ui's tick-based scroll runs, heading and row are
// already visible and its scrollIntoView is a no-op.
export function scrollSelectedItemIntoView(value: string) {
  const list = document.querySelector<HTMLElement>("[data-command-list]");
  const item = [
    ...(list?.querySelectorAll<HTMLElement>("[data-command-item]") ?? []),
  ].find((el) => el.dataset.value === value);
  if (!list || !item) return;
  const lb = list.getBoundingClientRect();
  const ib = item.getBoundingClientRect();
  if (ib.top >= lb.top && ib.bottom <= lb.bottom) return;
  // First row of a group: keep the group heading visible with the row.
  const heading = item.previousElementSibling
    ? null
    : item
        .closest("[data-command-group]")
        ?.querySelector<HTMLElement>("[data-command-group-heading]");
  const pad = 8; // list's p-2 padding
  if (ib.top < lb.top) {
    const anchor = heading ?? item;
    list.scrollTop += anchor.getBoundingClientRect().top - lb.top - pad;
  } else {
    list.scrollTop += ib.bottom - lb.bottom + pad;
  }
}
